export const SUGGESTED_VALIDATION_RESPONSE = {
    Parametros: {
        CETIP: "DEB123",
        VersaoDocumento: 2,
        Indexador: "CDI_Taxa",
        DataReferencia: "2026-09-14",
        PUPARReferencia: 1000.00,
        PUMTMReferencia: 990.00,
        SpreadCredito: 1.1699,
    },
    PUPAR: {
        ValorCalculado: 1000.12,
        DiferencaReferencia: 0.12,
        VariacaoPercentual: 0.012,
    },
    PUMTM: {
        ValorCalculado: 987.65,
        DiferencaReferencia: -2.35,
        VariacaoPercentual: -0.23737374,
    },
    Emissao: {SpreadEmissao: null, PrazoMedioEmissao: null},
    Indicadores: {
        PercentualPUPAR: 98.75314962,
        DuracaoMacaulay: {Dias: 126.50, Anos: 0.50198413},
        DuracaoModificada: null,
    },
    MemoriaCalculo: {
        PUPAR: [{
            IndiceFluxo: 1,
            DataReferencia: "2026-09-14",
            DataRentabilidadeInicio: "2026-03-14",
            DataEvento: "2026-09-14",
            DataLiquidacao: "2026-09-14",
            ValorNominal: 1000.00,
            ValorNominalAtualizado: 1000.00,
            Indexador: "CDI_Taxa",
            TaxaJuros: 1.1699,
            CalculoDias: "Uteis",
            CapitalizacaoJuros: "CDI + Spread",
            FatorJurosAcumulado: 1.00012,
            AtualizacaoMonetaria: 0.00,
            ValorJuros: 0.12,
            ValorIncorporacaoJuros: 0.00,
            ValorAmortizacao: 0.00,
            ValorAmortizacaoExtraordinaria: 0.00,
            ValorPagamento: 0.12,
            PUPAR: 1000.12,
        }],
        PUMTM: [{
            IndiceFluxo: 1,
            DataReferencia: "2026-09-14",
            DataRentabilidadeInicio: "2026-09-14",
            DataEvento: "2027-03-14",
            DataLiquidacao: "2027-03-15",
            ValorNominal: 1000.00,
            ValorNominalAtualizado: 1000.00,
            Indexador: "CDI_Taxa",
            TaxaJuros: 1.1699,
            CalculoDias: "Uteis",
            CapitalizacaoJuros: "CDI + Spread",
            ValorJuros: 60.00,
            ValorAmortizacao: 1000.00,
            ValorAmortizacaoExtraordinaria: 0.00,
            AtualizacaoMonetaria: 0.00,
            ValorPagamento: 1060.00,
            ValorPremio: 0.00,
            ValorFinal: 1060.00,
            TaxaLivreDeRisco: 13.50,
            TaxaMarcacao: 14.6699,
            FatorDesconto: 0.93174528,
            ValorPresenteFluxo: 987.65,
        }],
        FatorCorrecao: [],
    },
}

const createMemoryRows = (template, prefix, rowCount) => (
    Array.from({length: rowCount}, (_, index) => ({
        ...template,
        IndiceFluxo: index + 1,
        id: `${prefix}-${index + 1}`,
        // Nomes esperados por VALIDATION_MEMORY_COLUMNS atualmente.
        VN: template.ValorNominal,
        VNA: template.ValorNominalAtualizado,
        JurosCapitalizacao: template.CapitalizacaoJuros,
        FinanceiroJuros: template.ValorJuros,
        IncorporacaoJuros: template.ValorIncorporacaoJuros ?? null,
        FinanceiroAmortizacao: template.ValorAmortizacao,
        FinanceiroAmortizacaoExtraordinaria: template.ValorAmortizacaoExtraordinaria,
        Pagamento: template.ValorPagamento,
        Premio: template.ValorPremio ?? null,
        TaxaRiskFree: template.TaxaLivreDeRisco ?? null,
        ValorMTMFluxo: template.ValorPresenteFluxo ?? null,
    }))
)

export const createValidationExportMock = ({
    rowCount = 25,
    durationMacaulayUnit = "Anos",
} = {}) => {
    if (!Number.isInteger(rowCount) || rowCount < 0) {
        throw new Error("rowCount deve ser um inteiro maior ou igual a zero.")
    }
    if (!["Dias", "Anos"].includes(durationMacaulayUnit)) {
        throw new Error("durationMacaulayUnit deve ser Dias ou Anos.")
    }

    const data = SUGGESTED_VALIDATION_RESPONSE
    return {
        parameters: {
            dataReferencia: data.Parametros.DataReferencia,
            puparReferencia: String(data.Parametros.PUPARReferencia),
            pumtmReferencia: String(data.Parametros.PUMTMReferencia),
            spreadCredito: String(data.Parametros.SpreadCredito),
        },
        validationContext: {
            cetip: data.Parametros.CETIP,
            versaoDocumento: data.Parametros.VersaoDocumento,
        },
        results: {
            puparCalculado: data.PUPAR.ValorCalculado,
            deltaPupar: data.PUPAR.DiferencaReferencia,
            variacaoPercentualPupar: data.PUPAR.VariacaoPercentual,
            pumtmCalculado: data.PUMTM.ValorCalculado,
            deltaPumtm: data.PUMTM.DiferencaReferencia,
            variacaoPercentualPumtm: data.PUMTM.VariacaoPercentual,
            spreadEmissao: data.Emissao.SpreadEmissao,
            prazoMedioEmissao: data.Emissao.PrazoMedioEmissao,
            percentualPupar: data.Indicadores.PercentualPUPAR,
            durationModificada: data.Indicadores.DuracaoModificada,
            durationMacaulay: data.Indicadores.DuracaoMacaulay[durationMacaulayUnit],
        },
        memories: {
            pupar: createMemoryRows(data.MemoriaCalculo.PUPAR[0], "pupar", rowCount),
            pumtm: createMemoryRows(data.MemoriaCalculo.PUMTM[0], "pumtm", rowCount),
            fatorCorrecao: [],
        },
        premios: {
            recompra: {aplicavel: false, valor: null, memoria: []},
            conversibilidade: {aplicavel: false, valor: null, memoria: []},
        },
    }
}